import "./HeaderToolbar.scss";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ScrollPanel } from "primereact/scrollpanel";
import { Image } from "primereact/image";
import { NavLink } from "react-router-dom";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import AppRoutes from "../../Utils/AppRoutes";
import { ReactComponent as MappaSvg} from  '../ui-components/icons/Mappa.svg'
import { ReactComponent as WindSvg} from  '../ui-components/icons/Eolico.svg'
import { ReactComponent as BioSvg} from  '../ui-components/icons/Bioenergie.svg'
import { ReactComponent as GasSvg} from  '../ui-components/icons/Gas.svg'

type Props = {
    inProgressApi: boolean,
    toggleSidebar: () => void
}

const HeaderToolbar = (props: Props) => {
    const leftContents = (
        <React.Fragment>
            <ScrollPanel className="nav-bar">
                <div id="nav-bar">
                    <div className="flex flex-row flex-nowrap justify-content-between align-items-stretch">
                        <NavLink to={AppRoutes.HOME_ROUTE} title="Home" id="logo" className="flex">
                            { /*<Image alt="Logo sorgenia" src="https://www.sorgenia.it/sites/default/themes/sorgenia/assets/images/logo.svg" width="100pt" />*/ }
                            <img alt="Logo sorgenia" src="/LogoSorgenia.png" />
                        </NavLink>
                        <NavLink to={AppRoutes.HOME_ROUTE} className="flex align-items-center"><MappaSvg title="Mappa" /><span>MAPPA</span></NavLink>
                        <NavLink to={AppRoutes.CCGT_ROUTE} className="flex align-items-center"><GasSvg title="CCGT" /><span>CCGT</span></NavLink>
                        <NavLink to={AppRoutes.WIND_ROUTE} className="flex align-items-center"><WindSvg title="Eolico" /><span>EOLICO</span></NavLink>
                        <NavLink to={AppRoutes.BIO_ROUTE} className="flex align-items-center"><BioSvg title="Bio Energie" /><span>BIOENERGIE</span></NavLink>
                    </div>
                </div>
            </ScrollPanel>
        </React.Fragment>
    );

    const rightContents = (
        <React.Fragment>
            <Button icon="pi pi-bars" onClick={(event) => { props.toggleSidebar(); }} />
        </React.Fragment>
    );

    return (
        <div id="app-header">
            <Toolbar left={leftContents} right={rightContents} className="toolBar" />
            {props.inProgressApi && <ProgressBar mode="indeterminate" id="loader" />}
        </div>
    );
}

export default HeaderToolbar;